import React, { useState, useEffect } from "react";
import * as Icons from "../../assets/SVGs/index"; // Assuming your icons (e.g., delete icon) are in this directory

interface SVGUploadProps {
  onSVGChange: (file: File | null) => void;
  label?: string;
  uploadButtonText?: string;
  storageKey: string; // Unique key for localStorage
  defaultSVG?: string; // Default SVG URL or base64 string
}

const SVGUpload: React.FC<SVGUploadProps> = ({
  onSVGChange,
  label,
  uploadButtonText = "آپلود لوگو",
  storageKey,
  defaultSVG,
}) => {
  const [selectedSVG, setSelectedSVG] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (defaultSVG) {
      setSelectedSVG(defaultSVG);
    } else {
      setSelectedSVG(null);
    }
  }, [defaultSVG]);

  const handleSVGChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      if (file.type !== "image/svg+xml") {
        setError("فایل انتخابی باید یک SVG باشد.");
        return;
      }
      setError(null);

      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result as string;
        setSelectedSVG(base64String);
        localStorage.setItem(storageKey, base64String);
        onSVGChange(file);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleDeleteSVG = () => {
    setSelectedSVG(null);
    onSVGChange(null);
    localStorage.removeItem(storageKey);
  };

  return (
    <div className="w-full">
      {label && (
        <label htmlFor="svg" className="block mb-2 text-lg font-medium">
          {label}
        </label>
      )}
      <div className="flex items-center">
        <div
          className={`border-dashed border-2 border-[#B2B2B2] p-4 text-center rounded flex items-center transition-all duration-300 ${
            selectedSVG ? "w-[80%]" : "w-full"
          }`}
        >
          <input
            type="file"
            id="svg"
            name="svg"
            onChange={handleSVGChange}
            className="hidden"
            accept=".svg"
          />
          <label
            htmlFor="svg"
            className="cursor-pointer flex items-center justify-center"
          >
            <Icons.UploadIcon className="w-6 h-6 text-[#B2B2B2] ml-3" />
            <span className="ml-2 text-sm text-[#B2B2B2]">
              {uploadButtonText}
            </span>
          </label>
        </div>
        {selectedSVG && (
          <div className="relative">
            <div/>


<img
              src={selectedSVG}
              alt="Uploaded"
              className="w-[80px] h-[80px] object-cover border border-[#b2b2b2] rounded m-1"
            />
            <button
              onClick={handleDeleteSVG}
              className="bg-[#FAFAFA] absolute left-1 top-1 rounded p-1"
            >
              <Icons.DeleteIcon className="w-4 h-4" />
            </button>
          </div>
        )}
      </div>
      {error && <p className="text-red-500 mt-2">{error}</p>}
    </div>
  );
};

export default SVGUpload;

